import { render, staticRenderFns } from "./LicenseActionCard.vue?vue&type=template&id=4b968f2b&scoped=true"
import script from "./LicenseActionCard.vue?vue&type=script&lang=js"
export * from "./LicenseActionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b968f2b",
  null
  
)

export default component.exports